var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 2,
    viewBox: "0 0 9 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.264463 1.00031C0.264463 0.771641 0.37044 0.552341 0.55908 0.39065C0.747719 0.228959 1.00357 0.138122 1.27035 0.138122L7.30564 0.138123C7.57242 0.138123 7.82827 0.22896 8.01691 0.390651C8.20555 0.552342 8.31152 0.771642 8.31152 1.00031C8.31152 1.22897 8.20555 1.44827 8.01691 1.60996C7.82827 1.77165 7.57242 1.86249 7.30564 1.86249L1.27035 1.86249C1.00357 1.86249 0.747719 1.77165 0.55908 1.60996C0.37044 1.44827 0.264463 1.22897 0.264463 1.00031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.a48f79065e1f8a101f38699395ab6677.svg";
export { ForwardRef as ReactComponent };